import nginx from "nginx";
import { EEnvironmentName } from "@devowl-wp/react-frontend";
import { development } from "./development/development.js";
import { production } from "./production/production.js";
import { staging } from "./staging/staging.js";
const environmentName = Object.values(EEnvironmentName).includes(nginx.env.FRONTEND_APP_ENVIRONMENT) ? nginx.env.FRONTEND_APP_ENVIRONMENT : EEnvironmentName.Production;
const config = environmentName === "development" ? development : environmentName === "staging" ? staging : production;
export { config, environmentName };
